import type { RamadanGuidance } from "./types";

export const ramadanRehnumai: RamadanGuidance = {
  iftar: {
    health: {
      do: [
        {
          id: "water-dates",
          title: "Pehle pani aur 3 khajoor",
          description:
            "8-12 ghanton ki dehydration door hoti hai. Khajoor natural sugar se fast energy deti hai aur digestion ko activate karti hai.",
        },
        {
          id: "light-soup",
          title: "Halka soup ya shorbay se start",
          description:
            "Soup stomach ko aaram se prepare karta hai aur overeating se bachata hai. Lentil soup behtareen option hai.",
        },
        {
          id: "slow-eating",
          title: "Dheere dheere khayen",
          description:
            "Brain ko fullness signal bhejne mein 15-20 minutes lagte hain. Jaldi khane se bloating aur indigestion hoti hai.",
        },
        {
          id: "meal-break",
          title: "Iftar mein interval lein",
          description:
            "Maghrib ki namaz ke baad meal complete karein. Is se digestion behtar hota hai aur Maghrib ki namaz bhi timely ada ho jati hai.",
        },
        {
          id: "fruits-veggies",
          title: "Fruits aur vegetables zyada khayein",
          description:
            "Watermelon, cucumber, salad: hydration maintain karte hain aur fiber ki wajah se constipation se bachate hain.",
        },
        {
          id: "complex-carbs",
          title: "Complex carbs shamil karein",
          description:
            "Brown rice, whole wheat roti ya oats: slow energy release karte hain jo raat bhar barqarar rehti hai.",
        },
        {
          id: "grilled-food",
          title: "Grilled ya baked food prefer karein",
          description:
            "Fried vs grilled: grilled items mein calories kam hoti hain aur acidity ka risk bhi kam hota hai.",
        },
        {
          id: "water-intake",
          title: "Iftar se sehri tak 8 glasses pani",
          description:
            "Isay divide karein: iftar ke baad 2, raat ko 4, sehri mein 2. Nimbu pani electrolyte balance ke liye bhi acha hai.",
        },
      ],
      avoid: [
        {
          id: "cold-water",
          title: "Thanda pani na piyen",
          description:
            "Bohot thanda pani stomach ke blood vessels ko contract karta hai. Normal temperature pani behtar hai.",
        },
        {
          id: "fried-foods",
          title: "Fried items: samosa, pakore",
          description:
            "1 samosa mein 150-200 calories. Oil absorption high. Acidity, heartburn, weight gain ka sabab.",
        },
        {
          id: "sugary-drinks",
          title: "Artificial sugary drinks",
          description:
            "Soft drinks, sherbet, rooh afza zyada: immediate sugar spike phir crash. Thakan aur headaches.",
        },
        {
          id: "white-flour",
          title: "Maida ki cheezein",
          description:
            "Naan, pizza, burgers: refined carbs se blood sugar rapidly increase hota hai. Whole grain better.",
        },
        {
          id: "overeating",
          title: "Pet bhar kar khana",
          description:
            "Hadith: '1/3 khana, 1/3 pani, 1/3 hawa'. Zyada khana se neend aur ibadat dono affected.",
        },
        {
          id: "caffeine-after",
          title: "Iftar ke fauran baad chai/coffee",
          description:
            "Caffeine dehydration cause karta hai. Pehle meal digest hone dein, phir chai.",
        },
        {
          id: "spicy-food",
          title: "Bohot spicy aur masaledar",
          description:
            "Acidity, heartburn, indigestion. Khaas kar agar raat ko sohna mushkil ho.",
        },
        {
          id: "direct-sleep",
          title: "Iftar ke fauran baad sona",
          description:
            "Blood flow digestion mein laga rahta hai. 2-3 hours wait karein nahi toh acidity aur weight gain.",
        },
      ],
    },

    sunnah: {
      do: [
        {
          id: "dates-sunnah",
          title: "Taaza ya khushk khajoor se iftar",
          description:
            "Nabi ﷺ ne farmaya: 'Jab tum mein se koi rozay se ho to woh khajoor se iftar kare.' (Tirmidhi)",
        },
        {
          id: "iftar-dua",
          title: "Iftar ki dua parhna",
          description:
            "'Allahumma inni laka sumtu wa bika aamantu wa 'ala rizq-ika aftartu.' Rozay ki qabooliyat ki dua.",
        },
        {
          id: "water-first",
          title: "Paani ya doodh se iftar",
          description:
            "Agar khajoor na hon to paani ya doodh se iftar karein. Nabi ﷺ ne kabhi kabhi doodh se iftar kiya.",
        },
        {
          id: "maghrib-break",
          title: "Maghrib ki namaz ka intezar",
          description:
            "Thoda sa kha kar namaz parhna aur phir meal complete karna. Aisha (RA) se riwayat hai.",
        },
        {
          id: "iftar-meeting",
          title: "Dusron ko iftar dena",
          description:
            "Hadith: 'Jisne kisi rozay daar ko iftar diya, us ke liye rozay ke barabar ajr hai.' (Tirmidhi)",
        },
        {
          id: "moderation",
          title: "Iftar mein eitidal (moderation)",
          description:
            "Nabi ﷺ ne zyada khane se mana farmaya. Aap ﷺ kabhi pet bhar kar nahi khate they.",
        },
        {
          id: "iftar-jamaat",
          title: "Iftar jamaat ke saath",
          description:
            "Agar mumkin ho to family ya masjid mein iftar. Jamaat mein barkat hai.",
        },
      ],
      avoid: [
        {
          id: "israf-waste",
          title: "Israf aur ziyadati",
          description:
            "Allah farmata hai: 'Aur khao piyo lekin israf na karo, woh israf karne walon ko pasand nahi karta.' (Al-Araf 31)",
        },
        {
          id: "bidah-practices",
          title: "Ghair sunnah cheezein shamil karna",
          description:
            "Kuch log iftar ko mehfil-e-urs ki tarah bana lete hain. Sunnat se hatt kar cheezein.",
        },
        {
          id: "missed-maghrib",
          title: "Namaz mein deri karna",
          description:
            "Kuch log itne mashghool ho jate hain ke Maghrib ki jamaat miss ho jati hai. Namaz priority.",
        },
        {
          id: "extravagance",
          title: "Mehmaan nawazi mein ifrat",
          description:
            "Iftar parties mein itna paka liya jata hai ke waste hota hai. Sunnat mein sahoolat hai.",
        },
        {
          id: "impatience",
          title: "Be-sabri aur gussa",
          description:
            "Nabi ﷺ ne farmaya ke rozay daar ko gussa nahi karna chahiye. Iftar se pehle bhi.",
        },
      ],
    },
  },

  sehri: {
    health: {
      do: [
        {
          id: "high-protein",
          title: "High protein foods: eggs, yogurt, chicken",
          description:
            "Protein slow digestion hota hai, 8-10 ghante tak energy level maintain karta hai.",
        },
        {
          id: "complex-carbs",
          title: "Oats, brown rice, whole wheat roti",
          description:
            "Complex carbs glucose slowly release karte hain. Sir grams bhi behtareen option.",
        },
        {
          id: "fiber-rich",
          title: "Fiber ke liye fruits aur vegetables",
          description:
            "Apple, banana, berries, carrots: fiber se 14-16 ghante constipation nahi hoti.",
        },
        {
          id: "hydrating-foods",
          title: "Pani wali cheezein: cucumber, watermelon",
          description:
            "Din mein dehydration se bachate hain. Yogurt aur lassi bhi electrolytes provide karti hai.",
        },
        {
          id: "healthy-fats",
          title: "Healthy fats: olive oil, nuts, avocado",
          description:
            "Almonds, walnuts, olive oil: energy dense aur brain function improve karte hain.",
        },
        {
          id: "banana-energy",
          title: "Kela shamil karein",
          description:
            "Potassium se bharpoor, muscle cramps se bachata hai aur instant energy deta hai.",
        },
        {
          id: "water-balance",
          title: "2-3 glasses pani zaroor piyen",
          description:
            "Magar ek saath na piyen. Dheere dheere, 30-45 minutes mein distribute karein.",
        },
        {
          id: "dates-again",
          title: "2-3 khajoor sehri mein bhi",
          description:
            "Dates mein fiber, sugar, minerals. Poora din energy level maintain karte hain.",
        },
      ],
      avoid: [
        {
          id: "only-tea",
          title: "Sirf chai aur biscuit par guzara",
          description:
            "Caffeine dehydration karta hai. Biscuit mein refined flour aur sugar. 2-3 ghante mein hunger.",
        },
        {
          id: "salty-foods",
          title: "Namkeen aur processed foods",
          description:
            "Pickle, chips, packet noodles: sodium zyada hota hai. Din mein piyas barhti hai.",
        },
        {
          id: "fried-sehri",
          title: "Fried items sehri mein",
          description:
            "Paratha, fried fish: oil heavy hota hai. Acidity aur lethargy feel hoti hai.",
        },
        {
          id: "too-much-tea",
          title: "Chai/coffee zyada",
          description:
            "Diuretic effect se bathroom break zyada aur dehydration. 1 cup limit.",
        },
        {
          id: "simple-sugars",
          title: "Mithai, cakes, pastries",
          description:
            "Simple sugar se blood sugar spike phir crash. Dopahar tak kamzori.",
        },
        {
          id: "heavy-spicy",
          title: "Bohot spicy aur masaledar",
          description:
            "Din mein piyas aur acidity dono. Dil ki jalan aur bechaini.",
        },
        {
          id: "overeating-sehri",
          title: "Pet bhar kar khana sehri mein",
          description:
            "Neend affected. Digestive system overload. Halka khana behtar.",
        },
        {
          id: "cold-drinks",
          title: "Thande soft drinks",
          description:
            "Sugar aur cold temperature dono nuqsan. Pani ya doodh behtar.",
        },
      ],
    },

    sunnah: {
      do: [
        {
          id: "sehri-delay",
          title: "Sehri akhir waqt tak muakhkhar karna",
          description:
            "Nabi ﷺ ne sehri mein takheer ki. 'Meri ummat tab sehri kare jab tak muazzin azaan na de.' (Sahih Bukhari)",
        },
        {
          id: "sehri-blessing",
          title: "Sehri mein barkat hai",
          description:
            "Nabi ﷺ ne farmaya: 'Sehri karo kyunke sehri mein barkat hai.' (Sahih Bukhari)",
        },
        {
          id: "light-sehri",
          title: "Halki sehri bhi chhoden nahi",
          description:
            "Agar paani ka ghont hi sahi. Nabi ﷺ ne farmaya: 'Ek ghunt paani se bhi sehri karo.' (Musnad Ahmad)",
        },
        {
          id: "tahajjud-connection",
          title: "Sehri aur Tahajjud ka milna",
          description:
            "Salaf saleheen sehri se pehle Tahajjud parhte. Ibadat aur khana dono barkat.",
        },
        {
          id: "istighfar-time",
          title: "Sehri ke waqt istighfar",
          description:
            "Allah farmata hai: 'Woh seher ke waqt istighfar karte they.' (Al-Dhariyat 18)",
        },
        {
          id: "dates-sehri",
          title: "Khajoor sehri mein bhi",
          description:
            "Abu Hurairah (RA) se riwayat hai ke Nabi ﷺ ne farmaya: 'Behtareen sehri mumin ke liye khajoor hai.' (Abu Dawud)",
        },
        {
          id: "sunnah-foods",
          title: "Sunnah foods shamil karein",
          description:
            "Khajoor, doodh, sahi (barley ka shorba), sirka, zaitoon ka tel. In mein shifa hai.",
        },
        {
          id: "sehri-niyyat",
          title: "Sehri ke waqt niyyat",
          description:
            "Dil se niyyat karein ke is sehri ki barkat se rozay ki taqat mil rahi hai. Niyyat ibadat.",
        },
        {
          id: "namaz-fajr",
          title: "Fajr ki jamaat ka intezam",
          description:
            "Sehri is tarah karein ke Fajr ki jamaat masjid mein mil sake. Sahaba ka amal.",
        },
      ],
      avoid: [
        {
          id: "miss-sehri",
          title: "Sehri bilkul na chhorna",
          description:
            "Nabi ﷺ ne sehri ko chhornay se mana farmaya. Agar bhuk lage to thoda sa bhi kha len.",
        },
        {
          id: "sehri-before-midnight",
          title: "Aadhi raat se pehle sehri",
          description:
            "Sehri ka waqt subah sadiq se pehle hai. Aadhi raat ko kha lena sehri nahi.",
        },
        {
          id: "gross-negligence",
          title: "Fajr ki namaz se ghaflat",
          description:
            "Kuch log itni der sehri karte hain ke Fajr ki jamaat miss ho jati hai.",
        },
        {
          id: "wasteful-sehri",
          title: "Israf sehri mein bhi",
          description:
            "Sehri mein bhi zyada banana aur waste karna. Halka aur barakat wala khana.",
        },
      ],
    },
  },
};
